import type { Location } from "react-router-dom";
import {
  getAllUrls,
  getUrlsNoHeaderTop,
  getUrlsWithAmount,
} from "./routeHelpers";

const urls = getAllUrls();
const urlsWithAmount = getUrlsWithAmount(urls);
const urlsNoHeaderTop = getUrlsNoHeaderTop(urls);

export const showHeaderWithAmount = (location: Location): boolean =>
  urlsWithAmount.includes(location.pathname);

export const isSimpleHeader = (location: Location): boolean =>
  location.pathname === "/welcome";

export const hideSubHeader = (location: Location): boolean =>
  urlsNoHeaderTop.includes(location.pathname) ||
  !urls.includes(location.pathname) ||
  isSimpleHeader(location);

export const getAllUrlsForHeader = (): string[] => urls;
